export default class Produto {
  constructor(produto) {
    if (produto.id) this.id = produto.id;
    this.ativo = produto.ativo || '';
    this.nome = produto.nome || '';
    this.preco = produto.preco || '';
    this.categoria = produto.categoria || '';
    this.imagem = produto.imagem || '';
    this.descricao = produto.descricao || '';
    this.caracteristicas = produto.caracteristicas || '';
    this.embalagem = produto.embalagem || '';
    this.descricaoTecnica = produto.descricaoTecnica || '';
  }
}